import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { getOrderTotalPrice } from 'store/updateTicketing';
import { accessNested, displayWhen, joinClasses } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { Link } from 'components/core/link/link.js';
import PaymentLoader from 'components/shared/theaters/ticketing/gateways/paymentLoader';
import s from 'components/shared/theaters/ticketing/gateways/mastercardPaymentGateway/mastercardPaymentGateway.sss';
import bb from 'components/shared/theaters/ticketing/bottomBar.sss';

// const MASTERCARD_CHECKOUT_SRC = 'https://eu-gateway.mastercard.com/checkout/version/45/checkout.js';
const MASTERCARD_SESSION_SRC = 'https://eu-gateway.mastercard.com/form/version/45/merchant/%MERCHANTID%/session.js';

const TICKETING_MAIN_TEXT_COLOR_VARNAME = 'ticketing-mainTextColor';

const MastercardLogo = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 170" {...props}>
		<path d="M195.93 153.396v.405h.373c.082 0 .153-.02.204-.051.047-.032.075-.087.075-.153s-.028-.118-.075-.15a.358.358 0 0 0-.204-.05zm.376-.283c.193 0 .342.044.448.13s.158.204.158.354c0 .125-.04.228-.126.31a.613.613 0 0 1-.358.15l.495.57h-.385l-.46-.567h-.149v.566h-.322v-1.513zm-.098 2.036c.177 0 .342-.036.491-.102a1.252 1.252 0 0 0 .77-1.171c0-.177-.035-.342-.098-.495-.066-.154-.157-.291-.27-.405s-.248-.205-.402-.271c-.149-.063-.314-.095-.49-.095s-.347.032-.5.095c-.157.066-.295.157-.408.27s-.205.252-.268.406c-.067.153-.098.318-.098.495s.031.342.098.495c.063.157.154.29.268.405s.251.204.408.27c.153.067.322.103.5.103m0-2.904c.231 0 .443.043.648.13a1.645 1.645 0 0 1 .88.868c.086.196.13.409.13.633s-.044.436-.13.632-.204.37-.354.519a1.785 1.785 0 0 1-.526.35c-.205.086-.417.13-.649.13a1.704 1.704 0 0 1-1.187-.48c-.149-.15-.267-.322-.353-.519s-.13-.408-.13-.632.043-.437.13-.633a1.6 1.6 0 0 1 .354-.519c.149-.15.326-.267.53-.35.204-.086.42-.13.656-.13m-153.102-5.827c0-2.884 1.89-5.254 4.979-5.254 2.951 0 4.943 2.268 4.943 5.254s-1.992 5.254-4.943 5.254c-3.089 0-4.979-2.37-4.979-5.254m13.286 0v-8.205h-3.568v1.992c-1.132-1.477-2.849-2.404-5.183-2.404-4.602 0-8.21 3.607-8.21 8.617 0 5.014 3.608 8.618 8.21 8.618 2.334 0 4.051-.927 5.183-2.405v1.992h3.568zm120.577 0c0-2.884 1.89-5.254 4.979-5.254 2.955 0 4.943 2.268 4.943 5.254s-1.988 5.254-4.943 5.254c-3.089 0-4.98-2.37-4.98-5.254m13.29 0v-14.795h-3.571v8.582c-1.132-1.477-2.85-2.404-5.183-2.404-4.602 0-8.21 3.607-8.21 8.617 0 5.014 3.608 8.618 8.21 8.618 2.334 0 4.051-.927 5.183-2.405v1.992h3.572zm-89.575-5.423c2.299 0 3.776 1.443 4.154 3.981H96.32c.381-2.37 1.82-3.98 4.362-3.98m.07-3.195c-4.81 0-8.173 3.5-8.173 8.617 0 5.219 3.501 8.618 8.413 8.618 2.472 0 4.736-.617 6.728-2.299l-1.749-2.645c-1.375 1.097-3.128 1.718-4.774 1.718-2.3 0-4.394-1.065-4.908-4.02h12.185c.036-.444.071-.892.071-1.372-.035-5.116-3.195-8.617-7.792-8.617m43.084 8.617c0-2.884 1.89-5.254 4.979-5.254 2.951 0 4.943 2.268 4.943 5.254s-1.992 5.254-4.943 5.254c-3.089 0-4.979-2.37-4.979-5.254m13.286 0v-8.205h-3.568v1.992c-1.136-1.477-2.849-2.404-5.183-2.404-4.602 0-8.21 3.607-8.21 8.617 0 5.014 3.608 8.618 8.21 8.618 2.334 0 4.047-.927 5.183-2.405v1.992h3.568zm-33.437 0c0 4.98 3.466 8.618 8.755 8.618 2.472 0 4.118-.55 5.903-1.957l-1.714-2.884c-1.34.962-2.747 1.477-4.295 1.477-2.849-.035-4.943-2.094-4.943-5.254s2.094-5.218 4.943-5.254c1.548 0 2.955.515 4.295 1.478l1.714-2.884c-1.785-1.407-3.431-1.957-5.903-1.957-5.289 0-8.755 3.638-8.755 8.617m46.004-8.617c-2.059 0-3.399.962-4.326 2.404v-1.992h-3.537v16.41h3.572v-9.199c0-2.715 1.167-4.224 3.501-4.224.723 0 1.478.102 2.232.412l1.1-3.363c-.79-.31-1.819-.448-2.542-.448m-95.65 1.717c-1.718-1.132-4.084-1.717-6.693-1.717-4.158 0-6.834 1.992-6.834 5.253 0 2.677 1.993 4.327 5.663 4.842l1.686.24c1.957.275 2.88.79 2.88 1.717 0 1.269-1.304 1.992-3.74 1.992-2.473 0-4.257-.79-5.46-1.717l-1.68 2.778c1.956 1.442 4.428 2.13 7.104 2.13 4.739 0 7.486-2.232 7.486-5.356 0-2.885-2.162-4.394-5.734-4.908l-1.681-.244c-1.545-.204-2.783-.51-2.783-1.611 0-1.203 1.167-1.922 3.124-1.922 2.095 0 4.123.79 5.117 1.407zm46.039-1.717c-2.06 0-3.4.962-4.323 2.404v-1.992h-3.537v16.41h3.568v-9.199c0-2.715 1.168-4.224 3.502-4.224.723 0 1.477.102 2.232.412l1.1-3.363c-.79-.31-1.82-.448-2.542-.448m-30.451.412h-5.836v-4.979h-3.607v4.98h-3.328v3.26h3.328v7.487c0 3.807 1.478 6.075 5.698 6.075 1.548 0 3.332-.48 4.464-1.27l-1.03-3.057c-1.064.617-2.232.928-3.159.928-1.784 0-2.366-1.1-2.366-2.747v-7.415h5.836zm-53.353 16.41v-10.3c0-3.878-2.471-6.487-6.456-6.522-2.094-.036-4.256.617-5.769 2.92-1.131-1.82-2.915-2.92-5.423-2.92-1.752 0-3.465.514-4.805 2.436v-2.024H10.25v16.41h3.603v-9.097c0-2.849 1.58-4.362 4.02-4.362 2.37 0 3.568 1.545 3.568 4.327v9.132h3.608v-9.097c0-2.849 1.646-4.362 4.016-4.362 2.436 0 3.603 1.545 3.603 4.327v9.132z" fill={props.textColor || '#231f20'}/>
		<path d="M198.13 100.048V97.65h-.625l-.723 1.646-.72-1.646h-.628v2.397h.444V98.24l.676 1.56h.46l.676-1.564v1.812zm-3.965 0v-1.989h.801v-.404h-2.043v.404h.802v1.989z" fill="#f79410"/>
		<path d="M127.082 110.359H73.004V13.171h54.078z" fill="#ff5f00"/>
		<path d="M76.469 61.757c0-19.715 9.23-37.276 23.605-48.593A61.538 61.538 0 0 0 61.878-.052C27.745-.052.077 27.621.077 61.758s27.668 61.808 61.801 61.808a61.538 61.538 0 0 0 38.196-13.215C85.699 99.034 76.469 81.472 76.469 61.757" fill="#eb001b"/>
		<path d="M200.016 61.757c0 34.137-27.668 61.81-61.801 61.81a61.557 61.557 0 0 1-38.2-13.216c14.378-11.317 23.61-28.879 23.61-48.594s-9.232-37.276-23.61-48.593a61.557 61.557 0 0 1 38.2-13.216c34.133 0 61.801 27.673 61.801 61.81" fill="#f79e1b"/>
	</svg>
);

let loadedScript;
let id = 1;

const loadScript = src => new Promise((resolve) => {
	// Remove the previously loaded script if there's one
	if (loadedScript) loadedScript.parentNode.removeChild(loadedScript);

	const script = document.createElement('script');
	script.addEventListener('load', () => { resolve(); });
	script.src = src;
	document.body.appendChild(script);

	loadedScript = script;
});

const checkSdk = () => !!window.PaymentSession;

export default class MastercardPaymentGateway extends Component {

	constructor(props) {
		super(props);

		this.id = id++;

		const stylingVars = accessNested(props.appData, 'styling.variables', {});
		this.textColor = stylingVars[TICKETING_MAIN_TEXT_COLOR_VARNAME] || '#000';

		this.state = {
			loading: true,
			loadingText: ''
		};

		this.onFormSubmit = this.onFormSubmit.bind(this);

		const { paymentData } = props.ticketing;
		this.merchantId = paymentData.merchantId;
		this.sessionId = paymentData.sessionId;

		this.libUrl = MASTERCARD_SESSION_SRC.replace('%MERCHANTID%', this.merchantId);
	}

	componentDidMount() {
		this.loadSdk();
	}

	makeIOSKeyboardGoToSleep() {
		if (this.$textInput) {
			this.$textInput.focus();
			this.$textInput.blur();
		}
	}

	loadSdk() {
		const that = this;
		loadScript(this.libUrl).then(() => {
			that.setupSdk();
		}, (err) => {
			console.error(`MastercardPaymentGateway:loadSdk(): ${err}`);
		});
	}

	setupSdk() {
		if (!checkSdk()) {
			console.error('MastercardPaymentGateway:setupSdk(): Hosted Session library is not loaded in');
			return;
		}

		const that = this;
		that.setState({ loading: false });

		window.PaymentSession.configure({
			fields: {
				card: {
					number: '#mastercard-card-number' + that.id,
					securityCode: '#mastercard-security-code' + that.id,
					expiryMonth: '#mastercard-expiry-month' + that.id,
					expiryYear: '#mastercard-expiry-year' + that.id
				}
			},
			frameEmbeddingMitigation: ['javascript'],
			callbacks: {
				initialized: function () {
					that.setState({ loading: false });
				},
				formSessionUpdate: function (response) {
					if (response.status) {
						if (response.status === 'ok') {
							Store.emit(actions.PAYMENT_MESSAGE_RECEIVED, { payload: response });
						} else {
							const messages = [];
							if (response.status === 'fields_in_error') {
								if (response.errors.cardNumber) {
									messages.push('Card number invalid or missing.');
								}
								if (response.errors.expiryYear) {
									messages.push('Epiry year invalid or missing.');
								}
								if (response.errors.expiryMonth) {
									messages.push('Epiry month invalid or missing.');
								}
								if (response.errors.securityCode) {
									messages.push('Security code invalid.');
								}
							} else if (response.status === 'request_timeout') {
								messages.push('Session update failed with request timeout');
							} else if (response.status === 'system_error') {
								messages.push('Session update failed with system error');
							}
							Store.emit(actions.SET_TICKETING_MESSAGE, { message: messages });
						}
					} else {
						Store.emit(actions.SET_TICKETING_MESSAGE, { message: 'No response from gateway' });
					}
				}
			},
			interaction: {
				displayControl: {
					formatCard: 'EMBOSSED',
					invalidFieldCharacters: 'REJECT'
				}
			}
		});
	}

	onFormSubmit(event) {
		event.preventDefault();
		this.makeIOSKeyboardGoToSleep();
		window.PaymentSession.updateSessionFromForm('card');
	}

	render(props, { loading, loadingText }) {
		const {
			ticketing, // Object - the ticketing state
			theater,   // Object - the active theater
			currencyCopy = 'CURRENCY'
		} = props;

		const theaterName = accessNested(ticketing, 'meta.theaterName');

		return (
			<form onSubmit={this.onFormSubmit} class={joinClasses(s.container, props.class)}>
				{loading && (
					<PaymentLoader text={loadingText} bgColor="transparent" textColor={this.textColor} logoHeight="7rem">
						<MastercardLogo textColor={this.textColor} />
					</PaymentLoader>
				)}
				<div class={joinClasses('frameBuster', s.formWrapper)} style={displayWhen(!loading)}>
					<h1 class={s.header}>{getCopy('WHAT_PAYMENT_DETAILS')}</h1>
					<p class={s.instructions}>{getCopy('PROVIDE_PAYMENT_INFO', { THEATER_NAME: theaterName })}</p>
					<div class={s.cardNumberBlock}>
						<label for="mastercard-card-number">Card Number</label><br />
						<input class={s.mastercardField} id={'mastercard-card-number' + this.id} readonly />
					</div>
					<div class={s.expiryDateBlock}>
						<label for="mastercard-expiry-month">Expiry Date</label><br />
						<input class={s.mastercardField} id={'mastercard-expiry-month' + this.id} ref={$ref => this.$textInput = $ref} /> / <input class={s.mastercardField} id={'mastercard-expiry-year' + this.id} />
					</div>
					<div class={s.securityCodeBlock}>
						<label for="mastercard-security-code">CVV</label><br />
						<input class={s.mastercardField} id={'mastercard-security-code' + this.id} readonly />
					</div>
					<footer class={s.footer}>
						<p>
							<svg class={s.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
								<path d="M50.164 13.896c-12.817 0-23.292 10.446-23.342 23.252v6.956h-1.029a4.283 4.283 0 0 0-4.293 4.294v33.414a4.283 4.283 0 0 0 4.293 4.292h48.414a4.283 4.283 0 0 0 4.293-4.292V48.398a4.283 4.283 0 0 0-4.293-4.294h-.703v-6.956c-.05-12.806-10.523-23.252-23.34-23.252zm0 7.5c8.763 0 15.789 7 15.838 15.752v6.956H34.324v-6.956a15.785 15.785 0 0 1 15.84-15.752zM50 54.426a6.045 6.045 0 0 1 6.045 6.046 6.045 6.045 0 0 1-3.945 5.664l.9 7.152h-6l.9-7.154a6.045 6.045 0 0 1-3.945-5.662A6.045 6.045 0 0 1 50 54.427z" />
							</svg>
							<span class={s.encryption}>SSL Encryption</span>
							<span>powered by</span>
							<Link class={s.mastercardLogo} target="_blank" href="https://www.mastercard.com/gateway/about.html" renderCustomChild>
								<MastercardLogo textColor="none" />
							</Link>
						</p>
					</footer>
				</div>
				<div class={bb.wrapper}>
					<div class={bb.info}>
						<div class={bb.total}>
							{getCopy('TOTAL', {}, 'Total')}
							<span class={bb.totalAmount}>{getCopy(currencyCopy, { value: getOrderTotalPrice(ticketing) })}</span>
						</div>
					</div>
					<div class={bb.buttonWrapper}>
						<button class={bb.button} onClick={this.onFormSubmit} disabled={loading} style={{ maxWidth: '155px' }}>Pay</button>
					</div>
				</div>
			</form>
		);
	}

}
